import Markdown from "@irati/ui/src/Markdown"
import styled from "styled-components"

export const StyledMarkdown = styled(Markdown)`
  p {
    color: ${({theme}) => theme.colors.greys.white};
  }
`
export const ImageContainer = styled.div`
  width: 42px;
  height: 42px;
  border-radius: 50px;
  display: flex;
  justify-items: center;
  align-items: center;
  img {
    width: 28px;
    height: auto;
  }
  ${({theme}) => `
    padding: ${theme.spacing.one};
    background-color: ${theme.colors.primary2_400}
  `}
`
